/**
 * PackagesPanel
 *
 * Left column — lists all PACKAGE products.
 * Selecting one loads the middle column.
 */

import React from 'react';
import PropTypes from 'prop-types';
import './PackagesPanel.css';

const PackagesPanel = ({ packages, selectedId, onSelect, onCreatePackage, loading, isAdmin }) => {
  return (
    <div className="ph-panel">
      <div className="ph-panel__header">
        <h3 className="ph-panel__title">Packages</h3>
        <span className="ph-panel__count">{packages.length}</span>
      </div>

      <div className="ph-panel__body">
        {loading ? (
          <div className="ph-panel__loading">
            <div className="ph-panel__spinner" />
          </div>
        ) : packages.length === 0 ? (
          <div className="ph-panel__empty">No packages found</div>
        ) : (
          <ul className="ph-panel__list">
            {packages.map((pkg) => (
              <li key={pkg.id}>
                <button
                  className={`ph-panel__item ${selectedId === pkg.id ? 'ph-panel__item--active' : ''}`}
                  onClick={() => onSelect(pkg)}
                  type="button"
                >
                  <span className="ph-panel__item-name">{pkg.product_name}</span>
                  {pkg.linkedCommercialCount > 0 && (
                    <span className="ph-panel__item-badge">{pkg.linkedCommercialCount}</span>
                  )}
                  <svg
                    className="ph-panel__item-chevron"
                    width="16"
                    height="16"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </li>
            ))}
          </ul>
        )}
        {isAdmin && (
          <div className="ph-panel__actions">
            <button className="ph-panel__create-btn" onClick={onCreatePackage} type="button">
              + New Package
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

PackagesPanel.propTypes = {
  packages: PropTypes.array.isRequired,
  selectedId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onCreatePackage: PropTypes.func,
  loading: PropTypes.bool,
  isAdmin: PropTypes.bool,
};

export default PackagesPanel;
